<template>
  <div class="basic">
    <div class="basic-header">
      <p>基本信息</p>
    </div>
    <van-form label-width="7em" @submit="handleSubmit" ref="basicForm">
      <van-field
        required
        v-model="formInline.companyName"
        name="companyName"
        label="公司名称"
        placeholder="请输入公司名称"
        :rules="ruleInline.companyName"
      />
      <van-field
        v-model="formInline.companyNameEn"
        name="companyNameEn"
        label="英文名称"
        placeholder="请输入英文名称"
        :rules="ruleInline.companyNameEn"
      />
      <van-field
        required
        v-model="formInline.linkMan"
        name="linkMan"
        label="联系人"
        placeholder="请输入联系人"
        :rules="ruleInline.linkMan"
      />
      <van-field
        required
        v-model="formInline.linkTitle"
        name="linkTitle"
        label="职务"
        placeholder="请输入职务"
        :rules="ruleInline.linkTitle"
      />
      <van-field
        required
        v-model="formInline.telephone"
        name="telephone"
        label="座机"
        placeholder="示例：+86-XXX-XXXXXX"
        :rules="ruleInline.telephone"
      />
      <van-field
        required
        type="number"
        v-model="formInline.linkTelephone"
        name="linkTelephone"
        label="手机号"
        placeholder="请输入手机号"
        :rules="ruleInline.linkTelephone"
      />
      <van-field
        required
        v-model="formInline.linkEmail"
        name="linkEmail"
        label="邮箱"
        placeholder="请输入邮箱"
        :rules="ruleInline.linkEmail"
      />
      <van-field
        type="number"
        v-model="formInline.linkQQ"
        name="linkQQ"
        label="QQ"
        placeholder="请输入QQ"
        :rules="ruleInline.linkQQ"
      />
      <van-field
        v-model="formInline.website"
        name="website"
        label="公司网址"
        placeholder="请输入公司网址"
        :rules="ruleInline.website"
      />
      <div>
        <van-field
          readonly
          clickable
          name="addresss"
          :value="selectAddresTxt"
          right-icon="arrow"
          label="公司地址"
          placeholder="请选择公司地址"
          :rules="ruleInline.addresss"
          @click="showPicker = true"
        />
        <van-popup v-model="showPicker" round position="bottom">
          <van-picker
            show-toolbar
            :columns="areaList"
            @confirm="onConfirm"
            @cancel="showPicker = false"
          />
        </van-popup>
      </div>
      <van-field
        v-model="formInline.address"
        name="address"
        label="详细地址"
        placeholder="请输入详细地址"
        :rules="ruleInline.address"
      />
      <van-field
        required
        v-model="formInline.unifiedCode"
        name="unifiedCode"
        label="社会信用代码"
        placeholder="统一社会信用代码"
        :rules="ruleInline.unifiedCode"
      />
    </van-form>
  </div>
</template>

<script>
import { Toast } from "vant";
import mFormAddress from "@components/m-form/m-form-address.vue";
import { mapGetters, mapActions } from "vuex";
// import country from "@assets/js/country2";
export default {
  name: "register-form", // 参展申请 - 基本信息
  components: {
    mFormAddress,
  },
  data() {
    const that = this;
    const companyAddressValid = (value) => {
      if (
        that.formInline.addresss.country &&
        that.formInline.addresss.country === "中国"
      ) {
        // 中国 判断省份和城市是否选择
        if (!that.formInline.addresss.province) {
          return false;
        } else if (!that.formInline.addresss.city) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    };
    const validPhone = (value, callback) => {
      if (!value) {
        return false;
      } else if (/^[1][0-9]{10}$/.test(value)) {
        return true;
      } else {
        return false;
      }
    };
    const validEmail = (value, callback) => {
      if (!value) {
        return false;
      } else if (/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value)) {
        return true;
      } else {
        return false;
      }
    };
    const validunifiedCode = (value, callback) => {
      if (!value) {
        return true;
      }
      var patrn = /^[0-9A-Z]+$/;
      //var patrn=/[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/
      //18位校验及大写校验
      console.log(patrn.test(value), "正则的数据");
      if (value.length != 18 || patrn.test(value) == false) {
        return false;
      } else {
        return true;
      }
    };
    return {
      areaList: [],
      showPicker: false,
      showPicker2: false,
      cityCode: "", //省市区编号，默认
      loading: false,
      isInvoice: false,
      formInline: {
        // 企业基本信息
        companyName: "", // 公司名称
        companyNameEn: "", // 公司英文名称
        unifiedCode: "", // 统一社会信用代码
        telephone: "",
        address: "", // 详细地址
        addresss: {
          country: "", // 国家
          province: "", // 省份
          city: "", // 城市
          county: "", // 区县
        },
        // 展会联系人
        linkMan: "",
        linkTitle: "",
        linkMob: "",
        linkEmail: "",
        linkTelephone: "", // 电话号码
        linkQQ: "",
        linkWeChat: "",
      },
      formInline2: {
        // 企业基本信息
        companyName: "上海连战技术有限公司", // 公司名称
        companyNameEn: "lianzhan", // 公司英文名称
        unifiedCode: "91310118MA1JM12CX7", // 统一社会信用代码
        telephone: "86-123123-123123",
        address: "金沙江西路1555路慧创国际16号2层", // 详细地址
        addresss: {
          country: "中国", // 国家
          province: "上海", // 省份
          city: "嘉定", // 城市
          county: "", // 区县
        },
        // 展会联系人
        linkMan: "李某",
        linkTitle: "技术",
        linkMob: "86-123123-123123",
        linkEmail: "2624006658@qq.com",
        linkTelephone: "13122959676", // 电话号码
        linkQQ: "2624006658",
        linkWeChat: "xiansheng",
      },
      ruleInline: {
        // 企业基本信息
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "onBlur" },
        ],
        telephone: [
          { required: true, message: "请输入座机", trigger: "onBlur" },
        ],
        unifiedCode: [
          {
            required: true,
            message: "统一社会信用代码不能为空",
            trigger: "onBlur",
          },
          {
            message: "请输入正确的统一社会信用代码",
            validator: validunifiedCode,
            trigger: "onBlur",
          },
        ],
        // addresss: [{
        //   required: true,
        //   validator: companyAddressValid, trigger: "onBlur",
        //   message: '请完善公司地址'
        // }],
        // address: [
        //   { required: true, message: "请输入详细地址", trigger: "onBlur" },
        // ],

        // 展会联系人
        linkMan: [{ required: true, message: "请输入姓名", trigger: "onBlur" }],
        linkTitle: [
          { required: true, message: "请输入职务", trigger: "onBlur" },
        ],
        linkTelephone: [
          { required: true, message: "请输入手机号码", trigger: "onBlur" },
          { validator: validPhone, message: "手机号码有误", trigger: "onBlur" },
        ],
        linkEmail: [
          { required: true, message: "请输入邮箱", trigger: "onBlur" },
          {
            validator: validEmail,
            message: "邮箱地址有误",
            trigger: "onBlur",
          },
        ],
      },
      defaultList: [],
      uploadList: [],
      uploadName: "",

      basicInfo: null,
      validateList: [],
      ElepropName: "", //验证错误的prop名
      companyId: "", //公司ID
      isOption: true, //企业经营类型是否是选择框

      countryList: [],
      provinceArr: [],
      citiesArr: [],
      selectAddresTxt: "",
      selectAddresTxt2: "",
    };
  },
  computed: {
    ...mapGetters({
      formHeaders: "getFormHeaders",
      uploadUrl: "getUploadUrl",
      exhibitionId: "getExhibitionId",
      company: "getCompany",
    }),
  },
  async created() {
    //   this.areaList = country;
    let list = await this.getAllAddress();
    let a = this.processData(list);
    a.map((item) => {
      if (item.text == "中国") {
        if (item.children.length > 0) {
          item.children.map((item2) => {
            if (item2.children.length > 0) {
              item2.children.map((item3) => {
                delete item3.children;
              });
            }
          });
        }
      }
    });
    this.areaList = a;

    if (this.formInline.addresss && this.formInline.addresss.province) {
      this.selectAddresTxt = `${this.formInline.addresss.country}/${this.formInline.addresss.province}/${this.formInline.addresss.city}`;
    }
    if (
      this.formInline.invoiceMalingAdresss &&
      this.formInline.invoiceMalingAdresss.province
    ) {
      console.log("invoiceMalingAdresss", this.formInline.invoiceMalingAdresss);
      this.selectAddresTxt2 = `${this.formInline.invoiceMalingAdresss.country}/${this.formInline.invoiceMalingAdresss.province}/${this.formInline.invoiceMalingAdresss.city}`;
    }
  },
  methods: {
    ...mapActions({
      getAllAddress: "getAllAddress",
    }),

    processData(data) {
      return data
        .map((item) => {
          // 如果是中国相关的处理
          item.text = item.name;
          // 如果是外国（假设根据 text 判断），处理 `children` 格式
          if (item.treeName && !item.treeName.includes("中国")) {
            item.children = [
              { text: "", children: [{ text: "", children: "" }] },
            ];
          } else if (
            item.treeName.includes("中国台湾") ||
            item.treeName.includes("中国澳门") ||
            item.treeName.includes("中国香港")
          ) {
            item.children = [
              { text: "", children: [{ text: "", children: "" }] },
            ];
          } else {
            // 修改 children's 为 children
            if (item.childrens) {
              item.children = item.childrens;
              delete item.childrens;
            }

            // 递归处理子节点
            if (item.children && item.children.length > 0) {
              item.children = this.processData(item.children);
            }

            // 只保留省级数据，删除城市和县区
            if (item.treeLevel === 4) {
              return null; // 删除城市和县区数据
            }
          }

          return item;
        })
        .filter((item) => item !== null); // 过滤掉 null 项
    },

    getvalidate(prop, status, error) {
      if (status == false) {
        let opt = {
          prop: prop,
          status: status,
          error: error,
        };
        this.validateList.push(opt);
      }
    },

    deteleObject(obj) {
      var uniques = [];
      var stringify = {};
      for (var i = 0; i < obj.length; i++) {
        var keys = Object.keys(obj[i]);
        keys.sort(function (a, b) {
          return Number(a) - Number(b);
        });
        var str = "";
        for (var j = 0; j < keys.length; j++) {
          str += JSON.stringify(keys[j]);
          str += JSON.stringify(obj[i][keys[j]]);
        }
        if (!stringify.hasOwnProperty(str)) {
          uniques.push(obj[i]);
          stringify[str] = true;
        }
      }
      uniques = uniques;
      return uniques;
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          console.log(valid, "valid");
          resolve(valid);
        });
      });
    },
    handleSuccess(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList.push({
          name: this.uploadName,
          url: res.list[0],
          status: "finished",
        });
      } else {
        this.uploadName = "";
      }
    },
    handleFormatError(file) {
      this.uploadName = "";
      this.$Notice.warning({
        title: "文件格式是不正确的",
        desc: "请上传jpg或者png格式的图片",
      });
    },
    handleMaxSize(file) {
      this.uploadName = "";
      this.$Notice.warning({
        title: "文件大小超过限制",
        desc: "请上传小于3M的图片",
      });
    },
    handleBeforeUpload(e) {
      this.uploadName = e.name;
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Notice.warning({
          title: `最多上传${limitNum}张图片`,
        });
      }
      return check;
    },
    handleRemoveByArr(file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    async handleSubmit() {
      Toast.loading("loading...");
      setTimeout(() => {
        Toast.clear();
      }, 5000);
      let res = await this.validateHandle();
      console.log("res", res);
      return Promise.resolve(res);
    },
    async validateHandle() {
      return new Promise((resolve, reject) => {
        this.$refs.basicForm
          .validate()
          .then(() => {
            let form = this.formInline;
            let valid = true;
            // 营业执照
            let formValue = {
              companyName: form.companyName, // 公司名称
              companyNameEn: form.companyNameEn, // 公司英文名称
              unifiedCode: form.unifiedCode, // 统一社会信用代码
              address: form.address, // 详细地址
              country: form.addresss.country,
              province: form.addresss.province,
              city: form.addresss.city,
              linkMan: form.linkMan,
              telephone: form.telephone,
              linkTitle: form.linkTitle,
              linkTelephone: form.linkTelephone,
              linkEmail: form.linkEmail,
              linkMob: form.linkMob, // 电话号码
              linkQQ: form.linkQQ,
            };
            if (valid) {
              Toast.clear();
            }
            resolve({ valid: valid, form: formValue });
          })
          .catch((res) => {
            //验证失败
            this.$refs.basicForm.scrollToField(res[0].name, true);
            Toast.fail(res[0].message);
            resolve({ valid: false, form: null });
          });
      });
    },
    onConfirm(value) {
      this.formInline.addresss.country = value[0] || "";
      this.formInline.addresss.province = value[1] || "";
      this.formInline.addresss.city = value[2] || "";
      this.selectAddresTxt = `${
        this.formInline.addresss.country ? this.formInline.addresss.country : ""
      }${
        this.formInline.addresss.province
          ? "/" + this.formInline.addresss.province
          : ""
      }${
        this.formInline.addresss.city ? "/" + this.formInline.addresss.city : ""
      }`;
      this.showPicker = false;
    },
    onConfirm2(value) {
      this.formInline.invoiceMalingAdresss.country = value[0] || "";
      this.formInline.invoiceMalingAdresss.province = value[1] || "";
      this.formInline.invoiceMalingAdresss.city = value[2] || "";
      this.selectAddresTxt2 = `${
        this.formInline.invoiceMalingAdresss.country
          ? this.formInline.invoiceMalingAdresss.country
          : ""
      }${
        this.formInline.invoiceMalingAdresss.province
          ? "/" + this.formInline.invoiceMalingAdresss.province
          : ""
      }${
        this.formInline.invoiceMalingAdresss.city
          ? "/" + this.formInline.invoiceMalingAdresss.city
          : ""
      }`;
      this.showPicker2 = false;
    },
  },
};
</script>

<style scoped lang='scss'>
.basic {
  background-color: #ffff;

  /deep/ {
    .ivu-radio-checked .ivu-radio-inner {
      border-color: #d00300 !important;
    }

    .van-switch--on,
    .ivu-radio-inner:after {
      background-color: #d00300;
    }

    .van-button--info,
    .van-radio__icon--checked .van-icon,
    .ivu-switch-checked {
      border-color: #d00300;
      background-color: #d00300;
    }
  }

  &-header {
    width: 100%;
    height: 48px;
    background-color: #f2f2f2;
    padding: 0 20px;
    color: #353535;

    p {
      line-height: 48px;
      font-size: 15px;
    }

    span {
      width: 30px;
      height: 15px;
      background-color: #fff;
      margin: 0 15px;
    }
  }

  &-name {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-address {
    padding: 30px 0 10px 30px;
    background-color: #ededed;
  }

  &-phone {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-license {
    padding: 30px 0 10px 30px;
    background-color: #ededed;
  }

  .upload-btn {
    width: 105px;
    height: 105px;
    border: dotted 1px #bfbfbf;
    text-align: center;
    margin: 10px 16px;
    border-radius: 4px;

    img {
      display: inline-block;
      width: 25px;
      height: 25px;
      margin-top: 33px;
      margin-bottom: 10px;
    }

    div {
      font-size: 12px;
      color: #999;
    }
  }

  .license-img {
    display: flex;
    flex-wrap: wrap;

    &-list {
      line-height: 32px;
      padding: 0 10px;
      background-color: #fff;
      display: flex;
      align-items: center;
      margin-right: 10px;
      margin-bottom: 10px;

      span {
        color: #d00300;
        cursor: pointer;
      }

      .line {
        width: 1px;
        height: 24px;
        background-color: #e6e6e6;
        margin: 0 6px;
      }
    }
  }

  &-export {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-scale {
    padding: 30px 0 10px 30px;
    background-color: #ededed;
  }

  &-tech {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-link {
    padding: 0 30px;
    background-color: #ededed;

    .ivu-form-item {
      margin-bottom: 0;
      line-height: 48px;

      /deep/ .ivu-form-item-label {
        font-size: 18px;
        padding: 0;
      }
    }
  }

  &-links {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-leader {
    padding: 0 30px;
    background-color: #ededed;
    position: relative;

    .ivu-form-item {
      margin-bottom: 0;
      line-height: 48px;

      /deep/ .ivu-form-item-label {
        font-size: 18px;
        padding: 0;
      }
    }

    .above {
      position: absolute;
      left: 240px;
      top: 10px;
    }
  }

  &-leaders {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }

  &-invoiceType {
    padding: 0 30px;
    background-color: #ededed;
    line-height: 48px;
    display: flex;
    justify-content: space-between;

    .ivu-checkbox-wrapper {
      margin: 0;
    }

    span {
      color: #ff0000;
      margin-left: 5px;
    }
  }

  &-invoices {
    padding: 30px 0 10px 30px;
    background-color: #fff;
  }
}

.tip {
  padding: 10px 16px 0;

  .red {
    font-size: 12px;
    color: #f00;
  }

  .txt1 {
    font-size: 13px;
    color: #000;
    font-weight: bold;
  }

  .txt2 {
    font-size: 12px;
    color: #999;
  }
}

.gap {
  height: 15px;
  background: #f7f7f7;
  width: 100%;
}

.top-title {
  line-height: 50px;
  align-items: center;
  padding-left: 15px;
  font-size: 15px;
  color: #333;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e6e6e6;

  .line {
    content: "";
    width: 3px;
    height: 15px;
    background-color: #d00300;
    margin-right: 7px;
  }

  span {
    font-size: 15px;
    color: #f00;
  }

  &-left {
    flex: 1;
    text-align: right;
    display: flex;
    justify-content: flex-end;
    padding-right: 15px;
  }
}

.upload-btn2 {
  width: 105px;
  height: 105px;
  border: dotted 1px #bfbfbf;
  text-align: center;
  margin: 10px 16px;
  border-radius: 4px;
  position: relative;
  margin-left: 10px;

  img {
    position: absolute;
    width: 100%;
    height: 100%;
    margin: 0;
    top: 0;
    left: 0;
    z-index: 2;
  }

  .cover {
    position: absolute;
    background: rgba(0, 0, 0, 0.6);
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    z-index: 3;

    .icon {
    }
  }
}
</style>
